import { OnInit, Component } from '@angular/core';
import { EventStore } from '../service/event.store';
import { OnyxEvent } from '../models/event';

@Component({
  selector: 'pioneer-rsvp',
  templateUrl: './rsvp.component.html'
})
export class RsvpComponent implements OnInit {
  public onyxEvent: OnyxEvent;

  constructor(private eventStore: EventStore) {
  }

  ngOnInit(): void {
    this.eventStore.selectedEvent.subscribe(event => this.onyxEvent = event);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/rsvp/rsvp.component.ts